import Icon from 'vue-awesome/components/Icon'

Icon.register({
  accessible_forward_sharp: {
    raw: '<path fill="none" d="M0 0h24v24H0V0z"/><circle cx="18" cy="4.54" r="2"/><path d="M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm5-3.5h-3.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-3.12 7H18v5h2v-7.5z"/>',
    width: '24',
    height: '24'
  }
})
